<template>
  <v-app v-if="isLoading">
    <loading />
  </v-app>
  <div v-else>
    <v-col cols="12" class="pa-3">
      <v-row>
        <v-col cols="12" lg="8">
          <v-card
            class="EK-card rounded-xl border-top border-right rounded-tr-0 EK-shadow IMTOrange"
          >
            <v-data-table
              dense
              :headers="headers"
              :items="filterSubscribeList"
              :search="searchText"
              :items-per-page="10"
              :page.sync="page"
              @page-count="pageCount = $event"
              hide-default-footer
            >
              <template v-slot:top>
                <v-text-field
                  v-model="searchText"
                  color="IMThemeGray"
                  label="بحث في الجدول"
                  style="width: 280px"
                  append-icon="mdi-magnify"
                  class="mx-4"
                ></v-text-field>
              </template>
              <template v-slot:item="{ item, index }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <tr
                      v-on="on"
                      v-bind="attrs"
                      @click="goToDetails(subsList.findIndex(sub => sub.shopId == item.shopId))"
                      :class="{ active: id == (page-1)*10+index }"
                    >
                      <td>{{ item.shopName }}</td>
                      <td>
                        {{ getDate(item.subscribeStartDate, item.subscribeEndDate) }}
                      </td>
                      <td>
                        <subscription-state :type="subsFilterForm.subsType == 0 || subsFilterForm.subsType == -1 ? item.mainSubsState : 4" :isSmall="true">
                        </subscription-state>
                      </td>
                      <td>
                        <subscription-state :type="subsFilterForm.subsType == 1 || subsFilterForm.subsType == -1 ? item.notiSubsState : 4" :isSmall="true">
                        </subscription-state>
                      </td>
                      <td>
                        <subscription-state :type="subsFilterForm.subsType == 2 || subsFilterForm.subsType == -1 ? item.imgSubsState : 4" :isSmall="true">
                        </subscription-state>
                      </td>
                      <td>
                        <subscription-state :type="subsFilterForm.subsType == 3 || subsFilterForm.subsType == -1 ? item.offerSubsState : 4" :isSmall="true">
                        </subscription-state>
                      </td>
                    </tr>
                  </template>
                  <span>انقر لعرض التفاصيل</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <div class="w-100 pb-10 mt-10">
     
              <a-pagination 
              
             
              pageSize="10"
              v-model="page"
            :total="filterSubscribeList.length"
            
            :showTotal="(total) => `من أصل ${total} عنصر`"

              size="large"   show-quick-jumper />
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" lg="4">
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
<style lang="scss" scoped>
.active {
  background: rgba(0, 0, 0, 0.125) !important;
}
</style>
<style>
td {
  text-align: center;
}
.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
  padding: 4px 5px 2px 0 !important;
}
</style>
<script>
import loading from "@/components/loading";
import subscriptionState from "@/components/subscription-state.vue";
import { mapActions, mapGetters } from "vuex";
import aPagination from  'ant-design-vue/lib/pagination'
export default {
  components: {
    loading,
    subscriptionState,
    aPagination,
  },
  props: {
    id: String,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    searchText: "",
    headers: [
      {
        text: "اسم المشترك",
        value: "shopName",
        sortable: true,
      },
      {
        text: "تاريخ إشتراك بطاقة المعلومات",
        value: "subsDate",
        sortable: false,
      },
      {
        text: "بطاقة معلومات",
        value: "main",
        sortable: false,
      },
      {
        text: "اشعارات",
        value: "notification",
        sortable: false,
      },
      {
        text: "صور",
        value: "images",
        sortable: false,
      },
      {
        text: "عروض",
        value: "offers",
        sortable: false,
      },
    ],
  }),
  created() {
        this.page = Math.ceil(this.id / 10) + 1
        console.log(this.page)
        this.fetchSubscriptions();
        this.setBreadcrumbs([
            {
                text: "الاشتراكات",
                disabled: false,
                href: "/subscription",
            },
        ]);
  },
  computed: {
    ...mapGetters(["subsList", "isLoading", "filterSubscribeList", "subsFilterForm"]),
  },
  methods: {
    ...mapActions(["fetchSubscriptions", "setBreadcrumbs"]),
    getDate(start, end) {
      return (
        new Date(start).toISOString().substr(0, 10) +
        " -> " +
        new Date(end).toISOString().substr(0, 10)
      );
    },
    goToDetails(index) {
      if (index != this.id) {
        this.$router.push("./" + index);
      }
    },
  },
};
</script>
